import React from 'react'
import Layout from '../component/layout'

const LeaseApprovals = () => {
  return (
    <Layout>
      coming soon!
    </Layout>
  )
}

export default LeaseApprovals